module.exports = __webpack_public_path__ + "static/media/checkPremium.ef3011c0.svg";